import ActionTypes from '../constants/action-types';
import initialState from '../../data/videoPlayer';

const videoPlayerReducer = (state = initialState, action) => {
    switch (action.type) {

        case ActionTypes.SET_VIDEO_PLAYER_IS_PLAYING:
            return {
                ...state,
                isPlaying: action.payload,
            };

        case ActionTypes.SET_VIDEO_PLAYER_ID:
            return {
                ...state,
                videoId: action.payload,
            };

        case ActionTypes.SET_VIDEO_PLAYER_SOURCE:
            return {
                ...state,
                source: action.payload,
            };

        default: return state;
    }
};

export default videoPlayerReducer;
